/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _hasTouch = _interopRequireDefault(require("../../packages/hasTouch"));
var _getGlobal = require("../../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
var mobileTest = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(globalObject.navigator ? globalObject.navigator.userAgent : '');
var _default = _hasTouch.default && mobileTest;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/isMobile/index.js
// module id = 63
// module chunks = 0